/**
 * Replaces the `{{year}}`/`{{date}}` placeholders admins can put in the UI config footer text.
 */
export const resolveFooterText = (text: string): string => {
  const now = new Date();

  return text
    .replaceAll('{{year}}', String(now.getFullYear()))
    .replaceAll('{{date}}', now.toLocaleDateString());
};
